import { render, staticRenderFns } from "./SharePresetPopup.vue?vue&type=template&id=a0a5cd4e&"
import script from "./SharePresetPopup.vue?vue&type=script&lang=js&"
export * from "./SharePresetPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports